import { render, staticRenderFns } from "./TableOrders.vue?vue&type=template&id=68877a70"
import script from "./TableOrders.vue?vue&type=script&lang=js"
export * from "./TableOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports